import axios from 'axios'

const request = require("request");
const qs = require("qs");
const api = {};

const getAPI = function(address, onResponse) {
    axios.get(address)
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}

const getHeaderAPI = function(address, headers, onResponse) {
    axios.get(address, { headers })
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}

const getParamsAPI = function(address, params, onResponse) {
    axios.get(address, { params })
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}

const postAPI = function(address, param, onResponse) {
    axios.post(address, param)
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
};

const postImage = function(address, image, onResponse) {
    let formData = new FormData();
    formData.append('image', image);
    axios.post(address, formData, { "Content-Type": "multipart/form-data"})
        .then(res => onResponse(res.data))
        .catch(err => console.error(err));
}

const putAPI = function(address, param, onResponse) {
    axios.put(address, param, { "Content-Type": "application-json" })
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}

const patchAPI = function(address, param, onResponse) {
    axios.patch(address, param, { "Content-Type": "application-json" })
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}

const deleteAPI = function(address, onResponse) {
    axios.delete(address)
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}
const deleteParamsAPI = function(address, params, onResponse) {
    axios.delete(address, { params })
        .then((res) => { onResponse(res.data); })
        .catch((err) => { console.error(err); });
}

api.editUser = function(_userId, oldPassword, id, password, name, onResponse) { postAPI("/api/user", { _userId, oldPassword, id, password, name, }, onResponse); }

api.getLogin = function(onResponse) { getAPI("/api/login", onResponse); };
api.login = function(id, password, onResponse) { postAPI("api/login", { id, password, }, onResponse); };
api.logout = function(onResponse) { getAPI("/api/logout", onResponse); };

api.searchItems = function(filter, onResponse) { getParamsAPI("/api/search/items", { filter, }, onResponse); }

api.getPageOrder = function(_userId, filter, onResponse) { getParamsAPI("/api/order/getPage", { _userId, filter, }, onResponse); }
api.getAllOrder = function(_userId, filter, onResponse) { getParamsAPI("/api/order/getAll", { _userId, filter, }, onResponse); }
api.getOneOrder = function(_orderId, onResponse) { getParamsAPI("/api/order/getOne", { _orderId, }, onResponse); }
api.createOrder = function(_userId, orderItems, onResponse) { postAPI("/api/order/create", { _userId, orderItems }, onResponse); }
api.confirmOrder = function(_userId, _orderId, items, onResponse) { postAPI("/api/order/confirm", { _userId, _orderId, items, }, onResponse); }
api.deleteOrder = function(_orderId, onResponse) { postAPI("/api/order/delete", { _orderId }, onResponse); }

api.getOrderedItem = function(_itemId, onResponse) { getAPI("/api/orderedItem/" + _itemId, onResponse); }
api.getOrderedItems = function(filter, onResponse) { getParamsAPI("/api/orderedItem/list/all", { filter }, onResponse); }
api.getOrderedItemList = function(page, filter, onResponse) { getParamsAPI("/api/orderedItem/list/page", { page, filter }, onResponse); }
api.modifyOrderedItems = function(_itemId, item, onResponse) { postAPI("/api/orderedItem/modify/" + _itemId, { item }, onResponse); }
api.completeOrderedItem = function(_itemId, onResponse) { postAPI("/api/orderedItem/complete/" + _itemId, { }, onResponse); }
api.confirmCancelItem = function(_itemId, onResponse) { postAPI("/api/orderedItem/confirmCancel/" + _itemId, {}, onResponse); }

api.getFinishedItem = function(_itemId, onResponse) { getAPI("/api/finishedItem/" + _itemId, onResponse); }
api.getFinishedItems = function(filter, onResponse) { getParamsAPI("/api/finishedItem/list/all", { filter, }, onResponse); }
api.getFinishedItemList = function(page, filter, onResponse) { getParamsAPI("/api/finishedItem/list/page", { page, filter, }, onResponse); }
api.cancelFinishedItem = function(_itemId, onResponse) { postAPI("/api/finishedItem/cancel/" + _itemId, {}, onResponse); }
api.modifyFinishedItem = function(item, onResponse) { postAPI("/api/finishedItem/modify/item", { item }, onResponse); }
api.uploadFinishedItemImage = function(_itemId, imageFile, onResponse) { postImage("/api/finishedItem/uploadImage/" + _itemId, imageFile, onResponse); }

api.getPageParcelOrder = function(_userId, filter, onResponse) { getParamsAPI("/api/parcelOrder/getPage", { _userId, filter }, onResponse); }
api.getAllParcelOrder = function(_userId, filter, onResponse) { getParamsAPI("/api/parcelOrder/getAll", { _userId, filter, }, onResponse); }
api.getOneParcelOrder = function(_parcelOrderId, onResponse) { getParamsAPI("/api/parcelOrder/getOne", { _parcelOrderId }, onResponse); }
api.createParcelOrder = function(_partnerId, items, onResponse) { postAPI("/api/parcelOrder/create", { _partnerId, items }, onResponse); }
api.confirmParcelOrder = function(_userId, _orderId, items, onResponse) { postAPI("/api/parcelOrder/confirm", { _userId, _orderId, items }, onResponse); }
api.deleteParcelOrder = function(_parcelOrderId, onResponse) { postAPI("/api/parcelOrder/delete", { _parcelOrderId }, onResponse); }

api.getParcelItem = function(_parcelItemId, onResponse) { getAPI("/api/parcelItem/" + _parcelItemId, onResponse); }
api.getParcelItemList = function(page, filter, onResponse) { getParamsAPI("/api/parcelItem/list/page", { page, filter }, onResponse); }
api.modifyParcelItem = function(item, onResponse) { postAPI("/api/parcelItem/modify/item", { item }, onResponse); }
api.cancelParcelItem = function(item, onResponse) { postAPI("/api/parcelItem/cancel/item", { item }, onResponse); }
api.getAllParcelItems = function(filter, onResponse) { getParamsAPI("/api/parcelItem/list/all", { filter }, onResponse); }

api.getPartners = function(onResponse) { getAPI("/api/partner", onResponse); };
api.addPartner = function(partner, onResponse) { postAPI("/api/partner", { partner }, onResponse); };
api.editPartner = function(_partnerId, partner, onResponse) { putAPI("/api/partner/" + _partnerId, { partner }, onResponse); };
api.removePartner = function(_partnerId, onResponse) { deleteAPI("/api/partner/" + _partnerId, onResponse); };

api.calculatePartner = function(_id, dateStart, dateEnd, onResponse) { getParamsAPI("/api/partner/calculate/partner", { _id, dateStart, dateEnd, }, onResponse); };
api.calculateParcel = function(_id, dateStart, dateEnd, onResponse) { getParamsAPI("/api/partner/calculate/parcel", { _id, dateStart, dateEnd, }, onResponse); };

api.addWorker = function(_centerId, worker, onResponse) { postAPI("/api/worker/" + _centerId, { worker }, onResponse); };
api.editWorker = function(_workerId, worker, onResponse) { putAPI("/api/worker/"+_workerId, { worker, }, onResponse); };
api.removeWorker = function(_workerId, onResponse) { deleteAPI("/api/worker/" + _workerId, onResponse); };
api.calculateWorker = function(_id, dateStart, dateEnd, onResponse) { getParamsAPI("/api/worker/calculate", { _id, dateStart, dateEnd, }, onResponse); };

api.getProductList = function(_partnerId, onResponse) { getParamsAPI("/api/product/list/partner", { _partnerId }, onResponse); };
api.getAllProductList = function(onResponse) { getAPI("/api/product/list/all", onResponse); };
api.addProduct = function(_partnerId, product, onResponse) { postAPI("/api/product/new", { _partnerId, product }, onResponse); };
api.modifyProduct = function(product, onResponse) { postAPI("/api/product/modify", { product }, onResponse); };
api.removeProduct = function(_productId, onResponse) { postAPI("/api/product/delete", { _productId }, onResponse); }
api.uploadProductImage = function(_productId, imageFile, onResponse) { postImage("/api/product/uploadImage/" + _productId, imageFile, onResponse); }

api.getCenters = function(onResponse) { getAPI("/api/center", onResponse); };
api.addCenter = function(name, phone, regions, description, onResponse) { postAPI("/api/center", { name, phone, regions, description, regions }, onResponse); };
api.editCenter = function(_centerId, center, onResponse) { putAPI("/api/center/" + _centerId, { center }, onResponse); };
api.calculateCenter = function(_id, dateStart, dateEnd, onResponse) { getParamsAPI("/api/center/calculate", { _id, dateStart, dateEnd, }, onResponse); };

api.setStocks = function(_partnerId, products, onResponse) { postAPI("/api/stock/set/" + _partnerId, { products, }, onResponse); };
api.addStocks = function(_partnerId, products, onResponse) { postAPI("/api/stock/add/" + _partnerId, { products, }, onResponse); };
api.removeStocks = function(_partnerId, products, onResponse) { postAPI("/api/stock/remove/" + _partnerId, { products, }, onResponse); };
api.getAddedStocks = function(_partnerId, onResponse) { getAPI("/api/stock/add/" + _partnerId, onResponse); };
api.confirmAddedStocks = function(_partnerId, onResponse) { postAPI("/api/stock/add/confirm/" + _partnerId, {}, onResponse); };
api.getRemovedStocks = function(_partnerId, onResponse) { getAPI("/api/stock/remove/" + _partnerId, onResponse); };
api.confirmRemovedStocks = function(_partnerId, onResponse) { postAPI("/api/stock/remove/confirm/" + _partnerId, {}, onResponse); };
api.transferStocks = function(_productId, _fromCenterId, _toCenterId, transferCount, memo, onResponse) {
    postAPI("/api/stock/transfer/" + _productId, { _fromCenterId, _toCenterId, transferCount, memo }, onResponse);
};
api.confirmStocks = function(_partnerId, onResponse) { postAPI("/api/product/confirmStocks/" + _partnerId, {}, onResponse); };

api.getAllStockOrders = function(filter, onResponse) { getParamsAPI("/api/stockOrder/list/all", { filter }, onResponse); };
api.getStockOrderList = function(page, filter, onResponse) { getParamsAPI("/api/stockOrder/list/page", { page, filter }, onResponse); };
api.newStockOrder = function(_partnerId, _centerId, type, products, onResponse) { postAPI("/api/stockOrder/new", { _partnerId, _centerId, type, products }, onResponse); };
api.confirmStockOrder = function(_stockOrderId, onResponse) { postAPI("/api/stockOrder/confirm/" + _stockOrderId, { }, onResponse); };
api.deleteStockOrder = function(_stockOrderId, onResponse) { postAPI("/api/stockOrder/delete/" + _stockOrderId, { }, onResponse); };

api.getAllLogs = function(_userId, filter, onResponse) { postAPI("/api/log/getAll", { _userId, filter }, onResponse); }
api.getLogPage = function(_userId, page, filter, onResponse) { postAPI("/api/log/getPage", { _userId, page, filter }, onResponse); }
api.getAllStorageLogs = function(filter, onResponse) { postAPI("/api/log/storage/getAll", { filter }, onResponse); }
api.getStorageLogPage = function(page, filter, onResponse) { postAPI("/api/log/storage/getPage", { page, filter }, onResponse); }

api.searchAddress = function(address, onResponse) { getAPI("/api/search/address/"  + address, onResponse); }

api.temp = function(onResponse) { getAPI("/api/order/temp/execute", onResponse); };
api.test = function(onResponse) { getParamsAPI("http://www.gaongloballogis.com/survey.html", { phone: "010-1234-5678", worker: "아무개" }, onResponse); }

api.install = function(Vue) {
    Vue.prototype.$api = api;
};

export default api;


// WEBPACK FOOTER //
// ./src/api.js